import { useDispatch } from 'react-redux';

import { exportTotes } from '../../../../../store/inventory/inventory.actions';

/**
 * Custom hook that provides a function to export totes to CSV using Redux
 * @param {string} inventoryWarehouseId - The ID of the inventory warehouse
 * @returns {() => void} A function that exports totes to CSV
 */
export const useExportTotesCSV = (inventoryWarehouseId) => {
  const dispatch = useDispatch();

  return () => {
    if (!inventoryWarehouseId) {
      return;
    }

    dispatch(
      exportTotes({
        warehouseId: inventoryWarehouseId,
      }),
    );
  };
};
